import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
// import loginImageright from "../../assets/task/loginformimgright.svg";
import logoImage from "../../assets/task/Wizkind_logo_final 1.svg";
import { useAuth } from '../../context/AuthContext';
import { useMessageAuth } from '../../context/MessageAuthProvider';
import { ApolloError, useLazyQuery, useMutation } from '@apollo/client';
import { REQUEST_OTP } from '../../api/query';
import { showError, showSuccess } from '../../components/common/ToastNotification';
import Loader from '../../components/common/Loader';
import { WIZKIND_LOGIN_WITH_OTP } from '../../api/mutation';

interface NewLoginInputs {
    email: string;
    otp?: string;
}

const emailSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
});

const fullSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    otp: Yup.string()
        .length(6, 'OTP must be 6 digits')
        .required('OTP is required'),
});

const NewLogin: React.FC = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const { loginWithParams } = useMessageAuth();
    const [otpSent, setOtpSent] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        trigger,
    } = useForm<NewLoginInputs>({
        resolver: yupResolver(otpSent ? fullSchema : emailSchema),
    });

    //api
    const [requestOtp, { data: requestOtpData, loading: requestOtpLoading }] = useLazyQuery(
        REQUEST_OTP, {
        fetchPolicy: 'no-cache'
    }
    );

    const [loginWithOTP, { loading: loginWIthOtpLoading }] = useMutation(WIZKIND_LOGIN_WITH_OTP, {
        fetchPolicy: 'no-cache'
    })

    async function onSendOtp(): Promise<void> {
        const valid = await trigger('email');
        if (valid) {
            const email = getValues('email');
            // Simulate OTP send (replace with real API call)
            console.log(`Sending OTP to ${email}`);

            await requestOtp({
                variables: {
                    action: "login",
                    varification_type: "email",
                    email: email,
                }
            }).then((response: any) => {
                if (response.data && response.data.request_otp.status_code === 200) {
                    showSuccess(response.data.request_otp.message);
                    setOtpSent(true);
                }

                if (response.errors?.length > 0) {
                    showError(response.errors[0].message);
                }
            }).catch(error => {
                if (error instanceof ApolloError) {
                    showError(error.message);
                }
            })
        }
    };

    const onSubmit: SubmitHandler<NewLoginInputs> = async (data) => {
        try {
            const response = await loginWithOTP({
                variables: {
                    email: data.email,
                    otp: data.otp,
                },
            })

            if (response.data.wizkind_login_with_otp.status_code === 200) {
                const employee = response.data.wizkind_login_with_otp.employees[0];
                
                // Store employeeInfo for compatibility
                localStorage.setItem("employeeInfo", JSON.stringify(employee));
                sessionStorage.setItem("employeeInfo", JSON.stringify(employee));

                login(employee);

                // Inline login into Supabase Messaging
                const params = {
                    agency_id: employee.agency?.id || 1122,
                    email_id: employee.email_id || employee.email,
                    mobile_number: employee.contact_no,
                    role: employee.employee_roles?.[0]?.role_name || employee.access_type,
                    sso_id: employee.uuid,
                    first_name: employee.first_name,
                    last_name: employee.last_name,
                    uuid: employee.uuid,
                };

                if (params.sso_id && params.email_id) {
                    try {
                        await loginWithParams(params);
                    } catch (err) {
                        console.error("❌ Messaging login failed during auth:", err);
                    }
                }

                showSuccess(response.data.wizkind_login_with_otp.message)
                navigate("/dashboard");
                // history.goBack()
            }
            if (response.data.wizkind_login_with_otp.status_code === 400) {
                showError(response.data.wizkind_login_with_otp.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message);
            }
        }
    };

    return (
        <section className="flex items-center justify-between login_form_main_blg min-h-screen overflow-hidden">
           <div className="loginleft_details_blg flex w-[40%] mq1275:w-[50%] mq1170:w-f-[50%] mq991:w-full items-center ">
             <form onSubmit={handleSubmit(onSubmit)} className="w-full px-[120px] py-[100px] mx-auto p-4 space-y-4">
               <div className="grid justify-center">
                 <img src={logoImage} alt="" />
               </div>
                <div className="self-stretch flex-1 inputnew-div flex svg-dark-color flex-col items-start justify-start gap-[8px] text-left text-sm text-text-text-primary font-body-reg ">
                    <label className="self-stretch relative font-semibold dark:text-white">Email</label>
                    <input
                        type="email"
                        {...register('email')}
                        className="py-2.5 cursor-pointer self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] h-[21px] tabelin-input-dv rounded-radius-md bg-text-text-tertiary dark:text-white dark:bg-slate-700 overflow-hidden flex flex-row items-center justify-start px-[15px] border-[1px] border-solid  border-surface-border "
                    />
                    {errors.email && <p className="text-red-600">{errors.email.message}</p>}
                </div>

                {!otpSent ? (
                    <button
                        type="button"
                        onClick={onSendOtp}
                        className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue"
                    >
                        <span className="text-white text-sm">Send OTP</span>
                    </button>
                ) : (
                    <>
                        <div className="w-full self-stretch flex-1 inputnew-div flex svg-dark-color flex-col items-start justify-start gap-[8px] text-left text-sm text-text-text-primary font-body-reg ">
                            <label className="self-stretch relative font-semibold dark:text-white">OTP</label>
                            <input
                                type="text"
                                {...register('otp')}
                                className="py-2.5 cursor-pointer self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] h-[21px] tabelin-input-dv rounded-radius-md bg-text-text-tertiary dark:text-white dark:bg-slate-700 overflow-hidden flex flex-row items-center justify-start px-[15px] border-[1px] border-solid  border-surface-border "
                                maxLength={6}
                            />
                            {errors.otp && <p className="text-red-600">{errors.otp.message}</p>}
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-green-500 text-white cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue rounded hover:bg-green-600"
                        >
                            Login
                        </button>
                    </>
                )}
            </form>
           </div>
           <div className="loginright_blg flex w-[70%] mq1275:w-[50%] mq1170:w-f-[50%] mq991:hidden ">
               {/* <img src={loginImageright} alt="" className="" /> */}
           </div>
            {(requestOtpLoading || loginWIthOtpLoading) && (
                <Loader />
            )}
        </section>
    );
};

export default NewLogin;
